<div class="main-page consultas">
    <div class="container-fluid">
        <!-- LINHA TITULO + PESQUISA -->

        <div class="row align-items-center">
            <div class="col-12 my-2">
                <h1>
                    <a class="btn btn-voltar text-center mr-2" (click)="this.router.navigate(['/consultations'])" data-title="Voltar"><i
                            class="fas fa-arrow-left"></i></a>
                    Consultar Terminal
                </h1>
            </div>
        </div>

       <!--  <mat-progress-bar mode="indeterminate" *ngIf="loader"></mat-progress-bar> -->

        <div *ngIf="terminal?.data.length === 0 && !loader">
            <div class="row no-gutters mt-3">
                <p>Nenhum registro at&eacute; o momento...</p>
            </div>
            <div class="row no-gutters mt-3">
                <a (click)="this.router.navigate(['/terminal/create'])" mat-button color="primary"
                    class="btn ml-0 ml-sm-2 ml-md-3 btn-salvar my-2 my-md-0">
                    Criar um novo terminal
                </a>
            </div>
        </div>

        <div class="row no-gutters mt-3" *ngIf="terminal?.data.length > 0">
            <div class="mat-elevation table-content">
               <!--  <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field>
                        <mat-label>Campo</mat-label>
                        <select matNativeControl [(ngModel)]="typeFilter">
                            <option *ngFor="let filtro of filtros" value={{filtro.campo}}>
                                {{filtro.valor}}
                            </option>
                        </select>
                    </mat-form-field>
                    <mat-form-field fxFlex="40%" class="ml-2">
                        <input autofocus type="text" matInput placeholder="Filtro" [(ngModel)]="filter" />
                    </mat-form-field>
                    <button type="button" mat-icon-button (click)="handleFilter()">
                        <mat-icon>search</mat-icon>
                    </button>
                </div> -->

                <!-- (matSortChange)="handleSort($event)" -->

                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%" class="ml-2">
                     <mat-label>Filtrar por placa</mat-label>
                     <input matInput autocomplete="off"
                     (keyup)="this.applyFilter($event)" style="text-transform: uppercase;" placeholder="Ex: PKISO" #input>
                   </mat-form-field>
           
                </div>           

                <table mat-table [dataSource]="terminal" matSort class="mat-elevation-z8">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                        <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                    </ng-container>

                    <ng-container matColumnDef="cdNumeroTerminal">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Número Terminal</th>
                        <td mat-cell *matCellDef="let element">{{ element.cdNumeroTerminal }}</td>
                    </ng-container>

                    <ng-container matColumnDef="nmprotocolo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Modelo</th>
                        <td mat-cell *matCellDef="let element">{{ element.trackerModelName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="cdSim">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>SIM</th>
                        <td mat-cell *matCellDef="let element">{{ element.cdSim }}</td>
                    </ng-container>

                    <ng-container matColumnDef="cdPlaca">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Placa</th>
                        <td mat-cell *matCellDef="let element">{{ element.cdPlaca }}</td>
                    </ng-container>

                    <ng-container matColumnDef="dsEmail">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Email
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.dsEmail }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nmempresa">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Empresa/Filial/Divisão
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.nmempresa ? element.nmempresa : element.nmdivisao }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="update">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Editar"
                                *ngIf="this.permissionService.hasPermission('TERMINAL_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Editar">
                                <a (click)="this.router.navigate(['/terminal/edit/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/edit.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="clone">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Duplicar"
                                *ngIf="this.permissionService.hasPermission('TERMINAL_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Duplicar">
                                <a (click)="this.router.navigate(['/terminal/clone/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/duplic.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Visualizar"
                                *ngIf="this.permissionService.hasPermission('TERMINAL_ATUALIZACAO_FUNCIONALIDADE', this.permissions)" matTooltip="Visualizar">
                                <a (click)="this.router.navigate(['/terminal/view/' + element.id])" class="btn btn-link">
                                    <img height="20" src="assets/img/view.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="deleteTerminal(element)" class="btn btn-link"
                                *ngIf="this.permissionService.hasPermission('TERMINAL_DELECAO_FUNCIONALIDADE', this.permissions)" matTooltip="Apagar">
                                <img height="20" src="assets/img/trash-cadastro.svg" alt="" />
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 20, 40, 100]" showFirstLastButtons></mat-paginator>

                  <!--   <mat-paginator *ngIf="terminal.data.length" [pageSize]="this.page.size" (page)="handlePageChanged($event)"
                    [length]="this.page.totalElements" showFirstLastButtons></mat-paginator> -->
            </div>
        </div>
    </div>
</div>
